<script>
export default {
  name: "t-wrapped",
  functional: true,
  props: {
    'show':{
      type: Boolean,
      default: false
    }
  },
  render(h, ctx) {

    const children = ctx.children.filter(vnode => vnode.tag) // remove unnecessary text nodes

    if (children.length !== 1) {
      console.warn('This component accepts only one root node in its slot')
    }
    if (ctx.props.show) {
      return children[0]
    } else {
      return children[0].children
    }
  }
}
</script>
